import { SchemaRevision, SchemaVersion } from './project-type.model';

export class ActivityPackType {
    activityPackTypeId?: string;
    name: string;
    description?: string;
    icon: string;
    instanceId: string;
    isSelected: boolean;
    tagStandardId: string;
    schemaRevision?: SchemaRevision;
    schemaVersions?: SchemaVersion[];
    activityWorkFlow?: ActivityWorkFlowHierarchy[];
    editedDate?: string;
    isTaggedItemLocal?: boolean;
    schemaId?: string;
}

export class ActivityPackStatus {
    activityPackTypeStatusId: string;
    name: string;
    isSelected: boolean;
    colour: string;
    activityPackTypeStatusType: ActivityStatusType;
    schemaRevision?: SchemaRevision;
    schemaVersions?: SchemaVersion[];
    active?: boolean;
}

export class ActivityWorkFlowHierarchy {
    activityWorkFlowId?: string;
    activityPackTypeStatus: ActivityPackTypeStatus;
    next?: ActivityWorkFlowHierarchy[];
    description: string;
    editedDate: string;
}

export class ActivityPackTypeStatus {
    activityPackTypeStatusId?: string;
    // activityPackTypeStatusType: ActivityPackTypeStatusType;
    colour: string;
    schemaRevision?: SchemaRevision;
    schemaVersions?: SchemaVersion[];
    name: string;
    isSelected: boolean;
    editedDate?: Date;
    description?: string;
    function?: number;
}

export class ActivityPackTypeStatusType {
    activityPackTypeStatusTypeId?: string;
    index: number;
    name: string;
    colour: string;
}

// export class ActivityPackTypeStatus{
//   activityPackTypeStatusId: string;
//   color: string;
//   schemaRevision? :SchemaRevision;
//   schemaVersions?:SchemaVersion[];
// }
export class ActivityStatusType {
    name: string;
    index: number;
    activityPackTypeStatusTypeId: string;
    colour: string;
    activityPackTypeStatusId?: string;
    editedDate?: string;
    schemaId?: string;
    isSelected?: boolean;
    instanceId?: string;
}

export class ActivityIcon {
    isPublic: boolean;
    accountName: string;
    containerName: string;
    contentType: string;
    host: string;
    hostNameType: string;
    path: string;
    port: number;
    scheme: string;
}

export class ActivityTagStandard {
    tagStandardId: string;
    name: string;
    file: string;
    isTemplate: boolean;
}

export class DeleteActivityTypesPayload {
    activityPackTypeId: string;
    active: boolean;
}
export class activityPackTypeList {
    activityPackTypeId: string;
    isTaggedItemLocal: boolean;
    tagStandardId: string;
    editedDate: string;
    name: string;
    description: string;
}

export class Activitypacktypestatusfunctions {
    key: number;
    value: string;
}
